
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 3.414V7h3.586L15 3.414zM19 9h-4a2 2 0 01-2-2V3H5v18h14V9zM5 1h10.414L21 6.586V21a2 2 0 01-2 2H5a2 2 0 01-2-2V3a2 2 0 012-2zm8 12.414V18h-2v-4.586l-1.293 1.293-1.414-1.414L12 9.586l3.707 3.707-1.414 1.414L13 13.414z","fill-rule":"evenodd"}})])
          )
        }
      }
    